import disabledEmphasis from '../../../text/disabled-emphasis';

const primary = (params) => disabledEmphasis(params);

export default primary;
